
const digest = '0bd380cb7a088761f22c558a4f7f41e143b7d704b057b7871eaf58f7bb753246';
const classes = {"wrapper":"_wrapper_ufsyq_1","count":"_count_ufsyq_17"};
const css = `._wrapper_ufsyq_1 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-height: 0;
  padding: 16px 14px 10px 14px;
  color: #3e3f42;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.3;
}

._count_ufsyq_17 {
  flex: 0 1 auto;
  text-align: right;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  